import { StoreContext as e } from "./context.js";
import { useContext as t, useSyncExternalStore as n } from "react";
// src/design/forms/datepicker/core/models/use-date-picker-store.tsx
function r(r) {
	let i = t(e);
	if (!i) throw Error("no provider");
	return n(i.subscribe, () => r(i.getState()), () => r(i.getInitialState()));
}
export { r as useDatePickerStore };

//# sourceMappingURL=use-date-picker-store.js.map